export default "__VITE_ASSET__B2sb6WkY__ 640w, __VITE_ASSET__BOvjh81S__ 1024w, __VITE_ASSET__Csz4Vuxx__ 1920w";